import api from './api';

export interface VideoProgress {
  id?: number;
  user_id: number;
  video_id: number;
  course_id: number;
  completed: boolean;
  watched_duration: number;
  progress_percentage?: number; // Phần trăm tiến độ xem video (0-100)
  completed_at?: string;
  updated_at?: string;
}

export interface CourseProgress {
  progress: number;
  completed_videos: number;
  total_videos: number;
  video_progress: { [videoId: number]: VideoProgress };
}

export const videoProgressService = {
  markVideoComplete: async (videoId: number) => {
    const response = await api.post<{ message: string; video_progress: VideoProgress }>(
      `/video-progress/video/${videoId}/complete`
    );
    return response.data;
  },

  markVideoUncomplete: async (videoId: number) => {
    const response = await api.post<{ message: string; video_progress: VideoProgress | null }>(
      `/video-progress/video/${videoId}/uncomplete`
    );
    return response.data;
  },

  getCourseProgress: async (courseId: number) => {
    const response = await api.get<CourseProgress>(`/video-progress/course/${courseId}/progress`);
    return response.data;
  },

  getVideoProgress: async (videoId: number) => {
    const response = await api.get<{ video_progress: VideoProgress }>(
      `/video-progress/video/${videoId}/progress`
    );
    return response.data;
  },

  updateVideoProgress: async (videoId: number, data: { watched_duration: number; progress_percentage: number }) => {
    const response = await api.put<{ 
      message: string; 
      video_progress: VideoProgress;
      completed?: boolean;
      points_granted?: number;
    }>(`/video-progress/video/${videoId}/progress`, data);
    return response.data;
  },

  getCourseUsers: async (courseId: number) => {
    if (!courseId || courseId === null || courseId === undefined) {
      console.error('Invalid courseId:', courseId);
      throw new Error('Course ID is required');
    }
    const response = await api.get<{ users: any[]; enrollments: any[] }>(
      `/video-progress/course/${courseId}/users`
    );
    return response.data;
  },
};

